import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PageLayout from '../components/pageLayout';
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import RegisterForm2 from '../components/NewRegisterForm/RegisterForm';
import { bumpAuthSession, clearPersistedUserState } from '../core/authSession';
import { LOGOUT } from '../core/store/actions/types';

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const RegisterFormWithRecaptcha = () => {
    const { executeRecaptcha } = useGoogleReCaptcha();

    const getRecaptchaToken = async () => {
        if (!executeRecaptcha) {
            throw new Error('reCAPTCHA is still loading. Please wait a moment and try again.');
        }
        return executeRecaptcha('register');
    };

    return <RegisterForm2 getRecaptchaToken={getRecaptchaToken} />;
};

function RegisterPage() {
    const dispatch = useDispatch();

    useEffect(() => {
        // Drop stale sessions from prior registrations/logins so profile
        // upload cannot target a deleted or previous user's id.
        bumpAuthSession();
        localStorage.removeItem('token');
        clearPersistedUserState();
        dispatch({ type: LOGOUT });
    }, [dispatch]);

    if (!RECAPTCHA_SITE_KEY) {
        console.warn(
            'REACT_APP_RECAPTCHA_SITE_KEY is missing in web/.env — registration will fail if the server requires reCAPTCHA.'
        );
        return <PageLayout children={<RegisterForm2 />} />;
    }

    return (
        <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
            <PageLayout children={<RegisterFormWithRecaptcha />} />
        </GoogleReCaptchaProvider>
    );
}

export default RegisterPage;
